import { FC, useEffect, useState } from "react";
import Suspense from "../suspense/Suspense";
import { connect, ConnectedProps } from "react-redux";
import { questionManagementActionCreators } from "../../actions/questionManagementActions";
import { ApplicationState, AppThunkDispatch } from "../../store";
import QuestionManagementList from "./QuestionManagementList";
import { QuestionManagementEntry } from "../../store/questionManagement";
import DeleteQuestionManagementEntryModal from "./DeleteQuestionManagementEntryModal";

interface QuestionManagementProps extends ConnectedProps<typeof connector> {
}

const QuestionManagement: FC<QuestionManagementProps> = (props) => {
    const [questionManagementEntryToDelete, setQuestionManagementEntryToDelete] = useState<QuestionManagementEntry | null>(null);
    
    const { questionManagementState } = props;
    const { readQuestionManagementData } = props;

    const [isRaqOpen, setIsRaqOpen] = useState(true);
    const [isKnowledgeCentersOpen, setIsKnowledgeCentersOpen] = useState(true);
    const raqChevron = document.getElementById('raqChevron');
    const knowledgeCenterChevron = document.getElementById('knowledgeCenterChevron');

    useEffect(() => {
        if ((questionManagementState.data === undefined || questionManagementState.error) && !questionManagementState.isLoading) {
            readQuestionManagementData();
        }
    }, []);
    
    const handleQuestionManagementListDelete = (questionManagementEntry: QuestionManagementEntry) => {
        setQuestionManagementEntryToDelete(questionManagementEntry);
    }
    
    const handleModalClose = () => {
        setQuestionManagementEntryToDelete(null);
    }
    
    const isDeleteModalVisible = questionManagementEntryToDelete !== null;

    function handleRaqClick() {
        setIsRaqOpen(!isRaqOpen)
        raqChevron?.classList.toggle('chevronOpen', isRaqOpen);
    }

    function handleKnowledgeCenterClick() {
        setIsKnowledgeCentersOpen(!isKnowledgeCentersOpen)
        knowledgeCenterChevron?.classList.toggle('chevronOpen', isKnowledgeCentersOpen);
    }

    return (
        <>
            <DeleteQuestionManagementEntryModal isVisible={isDeleteModalVisible} questionManagementEntry={questionManagementEntryToDelete} onClose={handleModalClose} />
        
            <div className="question-list-container">

                <div className="questions-div">
                    <h2 className="question-section-h2" onClick={() => handleRaqClick()} >Recently Added Questions<svg id="raqChevron" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className={'feather feather-chevron-up chevronAdjust'}><polyline points="6 9 12 15 18 9" /></svg></h2>
                    {isRaqOpen &&
                        <Suspense isLoading={questionManagementState.isLoading && !isDeleteModalVisible} error={questionManagementState.error} errorDisplayMessage={"There was a problem reading RAQs. Please try again later"} data={questionManagementState.data}>
                            {(questionManagementData) => (
                                <QuestionManagementList questionManagementEntries={questionManagementData.raqs} onDelete={handleQuestionManagementListDelete} />
                            )}
                        </Suspense>
                    }
                </div>
                
                <div className="questions-div">
                    <h2 className="question-section-h2" onClick={() => handleKnowledgeCenterClick()} >Knowledge Centers<svg id="knowledgeCenterChevron" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className={'feather feather-chevron-up chevronAdjust'}><polyline points="6 9 12 15 18 9" /></svg></h2>
                    {isKnowledgeCentersOpen &&
                        <Suspense isLoading={questionManagementState.isLoading && !isDeleteModalVisible} error={questionManagementState.error} errorDisplayMessage={"There was a problem reading Knowledge Centers. Please try again later."} data={questionManagementState.data}>
                            {(questionManagementData) => (
                                <QuestionManagementList questionManagementEntries={questionManagementData.faqs} onDelete={handleQuestionManagementListDelete} />
                            )}
                        </Suspense>
                    }
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const questionManagementState = state.questionManagement;

    return { questionManagementState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    readQuestionManagementData: () => {
        dispatch(questionManagementActionCreators.readQuestionManagementData());
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(QuestionManagement);